import React, { lazy } from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { BookIcon, GiftIcon, CheckCircleIcon } from './Icons';
export function OfferSection() {
  const imgReveal = useScrollReveal();
  const contentReveal = useScrollReveal();
  return <section id="offer-section" className="py-20 bg-softwhite" data-id="element-124">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-125">
        <div className="text-center mb-16" data-id="element-126">
          <h2 className="text-3xl md:text-5xl font-playfair font-bold text-charcoal mb-6" data-id="element-127">
            Te presento el Sistema Completo{' '}
            <span className="text-sage" data-id="element-128">"Reseteo Hormonal H2"</span>
          </h2>
          <p className="text-xl text-charcoal-light font-sans max-w-2xl mx-auto" data-id="element-129">
            El único programa diseñado específicamente para la biología de la
            mujer de 35 a 50+ años.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-130">
          <div ref={imgReveal.ref} className={`relative reveal-scale ${imgReveal.isVisible ? 'visible' : ''}`} data-id="element-131">
            <div className="absolute inset-0 bg-sage/10 rounded-full blur-3xl -z-10 transform scale-110" data-id="element-132" />
            <img src="https://cdn.magicpatterns.com/uploads/dEvyu4nQtL7ZET645ewVsd/bundlereset.png" alt="Bundle Completo Reseteo Hormonal H2" className="w-full h-auto drop-shadow-2xl" loading="lazy" data-id="element-133" />
          </div>

          <div ref={contentReveal.ref} className={`space-y-6 reveal-right ${contentReveal.isVisible ? 'visible' : ''}`} data-id="element-134">
            <div className="bg-white p-6 rounded-xl border border-cream shadow-sm flex gap-4 items-start" data-id="element-135">
              <div className="w-12 h-12 bg-sage/10 rounded-lg flex items-center justify-center text-sage shrink-0" data-id="element-136">
                <BookIcon className="w-6 h-6" data-id="element-137" />
              </div>
              <div data-id="element-138">
                <h3 className="text-xl font-playfair font-bold text-charcoal mb-1" data-id="element-139">
                  Ebook Principal: El Efecto Reseteo Hormonal H2{' '}
                  <span className="text-charcoal-light line-through text-sm font-sans ml-2" data-id="element-140">
                    ($197)
                  </span>
                </h3>
                <p className="text-charcoal-light font-sans" data-id="element-141">
                  Tu mapa paso a paso para apagar el cortisol y sanar tu
                  metabolismo.
                </p>
              </div>
            </div>

            <div className="relative" data-id="element-142">
              <div className="absolute -left-3 top-1/2 -translate-y-1/2 w-6 h-px bg-cream" data-id="element-143" />
              <h4 className="text-sm font-sans font-bold text-gold uppercase tracking-widest mb-4 flex items-center gap-2" data-id="element-144">
                <GiftIcon className="w-4 h-4" data-id="element-145" /> Bonos de Acción Rápida
              </h4>

              <ul className="space-y-4" data-id="element-146">
                {[{
                title: 'BONO 1: Mapa del Nervio Vago',
                value: '$97',
                desc: 'La técnica física para detener el estrés en segundos.'
              }, {
                title: 'BONO 2: Lista de Compras Hormonal',
                value: '$67',
                desc: 'Tu guía de supermercado para no dudar nunca más.'
              }, {
                title: 'BONO 3: Protocolo Sueño Profundo',
                value: '$47',
                desc: 'Quema grasa mientras duermes plácidamente.'
              }, {
                title: 'BONO 4: Recetario Saciedad Real',
                value: '$47',
                desc: '30 platos deliciosos que apagan el hambre.'
              }].map((item, idx) => <li key={idx} className="flex gap-3 items-start" data-id="element-147">
                    <CheckCircleIcon className="w-5 h-5 text-sage mt-1 shrink-0" data-id="element-148" />
                    <div data-id="element-149">
                      <p className="font-sans font-bold text-charcoal" data-id="element-150">
                        {item.title}{' '}
                        <span className="text-charcoal-light line-through text-sm font-normal ml-1" data-id="element-151">
                          ({item.value})
                        </span>
                      </p>
                      <p className="text-sm text-charcoal-light font-sans" data-id="element-152">
                        {item.desc}
                      </p>
                    </div>
                  </li>)}
              </ul>
            </div>

            <div className="bg-cream-light p-4 rounded-lg border border-cream mt-6" data-id="element-153">
              <p className="font-sans text-charcoal text-center font-medium" data-id="element-154">
                <span className="text-gold font-bold" data-id="element-155">
                  + OTROS 11 BONOS EXCLUSIVOS ($97):
                </span>{' '}
                Desde guías de suplementos hasta rutinas de fuerza de 15 min.
              </p>
            </div>

            <div className="pt-6 border-t border-cream text-center lg:text-left" data-id="element-156">
              <p className="text-2xl font-playfair text-charcoal" data-id="element-157">
                VALOR TOTAL:{' '}
                <span className="font-bold line-through text-charcoal-light" data-id="element-158">
                  $552.00
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}